import { render, staticRenderFns } from "./UserTips.vue?vue&type=template&id=5d301ad9&scoped=true&"
import script from "./UserTips.vue?vue&type=script&lang=js&"
export * from "./UserTips.vue?vue&type=script&lang=js&"
import style0 from "./UserTips.vue?vue&type=style&index=0&id=5d301ad9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d301ad9",
  null
  
)

export default component.exports